export default __webpack_public_path__ + "static/media/rotateSvg.05d240ce.svg";